import {getCurrentYear} from '../../utils/commons'
import ExpertenReviewsLogo from './logo'
import {expertenReviewsStylesDE} from './styles'

const baseConfig = {
  domainName: 'expertenreviews' as const,
  domainType: 'eu' as const,
  siteName: 'Experten Reviews',
  favicon: '/favicons/expertenreviews.png',
  styles: expertenReviewsStylesDE,
}

const localeConfigs = {
  de: {
    measurementId: 'G-89D09C33R7',
    camelCaseUrl: 'ExpertenReviews.de',
    title: (category: string, count: string) =>
      `Top ${count} ${category} ${getCurrentYear()} | Experten Reviews & Vergleich`,
    description: (category?: string, count?: string) =>
      `Finde die besten ${count} ${category} im Vergleich ${getCurrentYear()} auf experten-reviews.de. Unabhängige Experten Reviews: Tests, Vergleiche & Kaufempfehlungen`,
    logo: <ExpertenReviewsLogo className="size-10 shrink-0 tablet:size-8" locale="de" />,
  },
}

export const createConfig = (locale: string = 'de') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.de
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
